import React, { PureComponent } from 'react'
import TextField from '../TextField'

import { ReactComponent as OnIcon } from './eye.svg'
import { ReactComponent as OffIcon } from './eye-off.svg'
import PasswordFieldButton from './PasswordFieldButton'

class PasswordField extends PureComponent {
  state = { visible: false }

  toggleVisible = event => this.setState(state => ({ visible: !state.visible }))

  render() {
    const { visible } = this.state
    const Icon = visible ? OffIcon : OnIcon
    const type = visible ? 'text' : 'password'

    return (
      <TextField
        {...this.props}
        type={type}
        suffix={
          <PasswordFieldButton onClick={this.toggleVisible}>
            <Icon />
          </PasswordFieldButton>
        }
      />
    )
  }
}

export default PasswordField
